require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./domestic-violence-police-units.json") })
        }
      }, "path---domestic-violence-police-units");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---domestic-violence-police-units!./.cache/json/domestic-violence-police-units.json
// module id = 877
// module chunks = 231608221292675